import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import './App.css';
import Chat from "./Chat";
import DOMPurify from "dompurify";
import { v4 as uuidv4 } from 'uuid';

function ViewComponent() {
  const questions = useSelector((state) => state.questions.questions);
  const passage = useSelector((state) => state.questions.passage);
  const [question, setQuestion] = useState(null);
  const [questionId, setQuestionId] = useState(null);

  const storedUuid = sessionStorage.getItem('sessionUuid');
  const sessionUuid = storedUuid || uuidv4();
  sessionStorage.setItem('sessionUuid', sessionUuid);

  const { count: viewId } = useParams();
  const sanitizedHTML = DOMPurify.sanitize(passage);

  useEffect(() => {
    const question = questions.questions[parseInt(viewId) - 1];
    if (question) {
      setQuestion(question);
      setQuestionId(question.id);
    }
  }, [questions, viewId]);

  if (!question) {
    return (
      <div className="loading-container">
        <div className="loader"></div>
        <div className="loading">No question found</div>
      </div>
    );
  }

  return (
    <div className="content-card">
      <div>
        <div className="passage-container">
          <div dangerouslySetInnerHTML={{ __html: sanitizedHTML }} />
        </div>
        <h3 className="question-title">{question.description}</h3>
      </div>
      <div>
        <Chat viewId={viewId} questionId={questionId} sessionId={`${viewId}_${sessionUuid}`} />
      </div>
    </div>
  );
}

export default ViewComponent;
